import { Button } from '@cropler/ui-kit';

import styles from './styles.module.scss';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

/* isFullView: top: 0, full screen height */
/* isFixedView: top: - header, full screen height */

export const Panel = ({ children, title, subtitle, isRelative, isFullView, isFixedView, isNoMainMenu, setActivePanel }) => {
  return (
    <>
      <div className={styles.panelBlackout}></div>
      <div
        className={`${styles.panel} ${isRelative ? styles.panelRelative : ''} ${isFullView ? styles.panelFull : ''} ${isFixedView ? styles.panelFullFixed : ''} ${isNoMainMenu ? styles.panelWithoutMenu : ''}`}
      >
        <div className={styles.panelHeader}>
          <div>
            {subtitle && <div className={styles.panelSubtitle}>{subtitle}</div>}
            <h2 className={styles.panelTitle}>{title}</h2>
          </div>
          <Button
            className={styles.panelClose}
            type="default"
            icon={<CroplerIcon name="close" />}
            onClick={() => setActivePanel(false)}
          />
        </div>
        <div className={`${styles.panelBody} custom-scroll-small`}>{children}</div>
      </div>
    </>
  );
};
